import { QueryHookOptions, useQuery } from '@apollo/client';
import gql from 'graphql-tag';

// GraphQL query
const streakHistoryByUserQuery = gql`
  query GetStreakHistoryByUser($userId: String!) {
    streakHistoryByUser(userId: $userId) {
      _id
      userId
      currentStreak
      longestStreak
      lastUpdatedAt
      history {
        earnedAt
        seen
        streakCount
      }
    }
  }
`;

// Types
export type TStreakHistory = {
  earnedAt: string;
  seen?: boolean;
  streakCount: number;
};

export type TUserStreakHistory = {
  _id: string;
  userId: string;
  currentStreak: number;
  longestStreak: number;
  lastUpdatedAt?: string;
  history: TStreakHistory[];
};

export type TQueryStreakHistoryByUser = {
  streakHistoryByUser: TUserStreakHistory | null;
};

// React hook
export function useGetStreakHistoryByUserQuery(
  options?: QueryHookOptions<TQueryStreakHistoryByUser, { userId: string }>,
) {
  return useQuery<TQueryStreakHistoryByUser, { userId: string }>(streakHistoryByUserQuery, options);
}
